import { makeAutoObservable } from 'mobx';
import { InvoicePaymentsCountDetailDto } from '../../../../defs/api';

export class InvoicePaymentsCountDetailMobxDto implements InvoicePaymentsCountDetailDto {
    monthly?: number;

    halfyearly?: number;

    yearly?: number;

    constructor() {
        makeAutoObservable(this);
    }

    static create(dto: InvoicePaymentsCountDetailDto): InvoicePaymentsCountDetailMobxDto {
        const mobxDto = new InvoicePaymentsCountDetailMobxDto();
        return Object.assign(mobxDto, dto);
    }

    static createFromArray(dtos: InvoicePaymentsCountDetailDto[]): InvoicePaymentsCountDetailMobxDto[] {
        return dtos.map((dto) => InvoicePaymentsCountDetailMobxDto.create(dto));
    }
}
